module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/fridge/steel.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/fridge/steel.jpg
// module id = 567
// module chunks = 0